var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDeleteInboxIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.962,
    height: 14,
    viewBox: "0 0 11.962 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght300_GRAD-25_opsz20",
    d: "M221.732-769.306a1.33,1.33,0,0,1-.976-.4,1.33,1.33,0,0,1-.4-.976v-10.564h-1.081v-1.1h3.81v-.958h4.342v.957h3.81v1.1h-1.081v10.556a1.337,1.337,0,0,1-.4.989,1.337,1.337,0,0,1-.978.4Zm7.322-11.945h-7.6v10.564a.275.275,0,0,0,.079.2.274.274,0,0,0,.2.079h7.04a.27.27,0,0,0,.194-.088.27.27,0,0,0,.088-.194Zm-5.547,9.223h1.1v-7.6h-1.1Zm2.393,0H227v-7.6h-1.1Zm-4.449-9.223v0Z",
    transform: "translate(-219.271 783.306)",
    fill: "#8d8d8d"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteInboxIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/deleteInboxIcon.1e3dde1a.svg";
export { ForwardRef as ReactComponent };